import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { ENVS } from "./envs";

// Detect test environment
const isTestEnvironment =
  (typeof window !== "undefined" &&
    window.location.hostname === "localhost" &&
    window.location.port === "3001") ||
  process.env.NODE_ENV === "test" ||
  process.env.PLAYWRIGHT_BASE_URL;

// Only initialize Firebase if we have valid config and we're not in test environment
const hasValidFirebaseConfig =
  ENVS.firebaseProjectId &&
  ENVS.storageBucket &&
  ENVS.firebaseProjectId !== "dummy" &&
  ENVS.storageBucket !== "dummy";

let app: any = null;
let storage: any = null;

if (hasValidFirebaseConfig && !isTestEnvironment) {
  try {
    const firebaseConfig = {
      projectId: ENVS.firebaseProjectId,
      storageBucket: ENVS.storageBucket,
    };

    // Initialize App
    app = initializeApp(firebaseConfig);

    // Initialize Storage
    storage = getStorage(app);
  } catch (error) {
    console.warn("Firebase initialization failed:", error);
  }
}

export { storage };
